export default "__VITE_ASSET__d0c397b8__"